export const InfoMessages = {
  cancelSubscription:
    "Cancelling your subscription will result in loss of access to Premium tools and limit your execution capabilities",
  downgradeSubscription:
    "Your current subscription will be downgraded at the end of the current billing cycle.",
  upgradeSubscription:
    "Your new subscription will start from today, and you will be charged the new subscription price.",
  upgradeSubscriptionProration:
    "Your new subscription will start from today. You will be charged the difference between new subscription price and prorated current subscription price based on the no. of credits remaining.",
};
export const PieColorsMap = {
  remaining: "#247EFE",
  spent: "#FF754C",
  extra: "#ee140e",
  savedTime: "#0045CB",
  aboveAvgTime: "#EEEFF2",
};

export const UserColorsMap = ["#247efe", "#01cd8c", "#ffce73", "#2be2e5", "#144583"];

export const PERIOD_OPTIONS = [
  { value: "this_month", label: "This month" },
  { value: "this_year", label: "This year" },
  { value: "all_time", label: "All time" },
];

export const CREDITS_DATE_PREFIX = "credits_usage";

// Tab constants for Credits page
export const CREDITS_TABS = {
  MY_USAGE: "my-usage",
  ORG_USAGE: "org-usage",
  PLANS: "plans",
  TOKENS: "tokens",
} as const;

export type CreditsTabType = (typeof CREDITS_TABS)[keyof typeof CREDITS_TABS];
